define("powergen/views/system",
  [],
  function() {
    "use strict";
    var SystemView;

    SystemView = Ember.View.extend({
      tagName: 'section',
      classNames: ['system'],
      classNameBindings: ['context.improvementsComplete:is-complete', 'context.isSubmitted'],
      click: function(e) {
        return this.get('controller').send('viewDidClick', e);
      }
    });


    return SystemView;
  });